module.exports = __webpack_public_path__ + "media/images/lb/032-1556ff3644125bf76755332b956c0e1b.svg";